import { useState } from "react";
import { clearLocalData, isLocalStorageSupported } from "../storage/localStore";

interface LocalDataControlsProps {
  canSave: boolean;
  onSave: () => Promise<void>;
}

export function LocalDataControls({ canSave, onSave }: LocalDataControlsProps) {
  const [status, setStatus] = useState<string | null>(null);
  const supported = isLocalStorageSupported();

  async function handleSave() {
    await onSave();
    setStatus("Reglas guardadas en este navegador (IndexedDB). Se aplicarán la próxima vez que ejecutes este escenario.");
  }

  async function handleClear() {
    await clearLocalData();
    setStatus("Datos locales eliminados.");
  }

  if (!supported) return null;

  return (
    <section aria-labelledby="local-data-heading">
      <h2 id="local-data-heading" className="section-heading">
        Datos locales
      </h2>
      <div className="panel">
        <p className="field-hint">
          Puedes guardar las reglas de máscara elegidas en este navegador (opt-in, solo la configuración, nunca el
          dataset) para no repetirlas la próxima vez.
        </p>
        <div className="action-row">
          <button type="button" className="button button-secondary" onClick={() => void handleSave()} disabled={!canSave}>
            Guardar reglas en este navegador
          </button>
          <button type="button" className="button button-danger" onClick={() => void handleClear()}>
            Eliminar datos locales
          </button>
        </div>
        {status ? (
          <p role="status" className="field-hint">
            {status}
          </p>
        ) : null}
      </div>
    </section>
  );
}
